export default "__VITE_ASSET__DzNEx_hC__"